// extracted by mini-css-extract-plugin
module.exports = {"error":"#ff4040","success":"#28cb93","primary-color":"#00bfb2","dark-grey-color":"#444","container":"AddProponent_container__1xaw2","icon":"AddProponent_icon__BRbzr"};